import api from '../api/axios';
import { Item, ItemInput } from '../types/item';

export const itemService = {
  list: async (): Promise<Item[]> => {
    const response = await api.get<Item[]>('items/');
    return response.data;
  },

  create: async (data: ItemInput): Promise<Item> => {
    const response = await api.post<Item>('items/', data);
    return response.data;
  },

  remove: async (id: number): Promise<void> => {
    await api.delete(`items/${id}/`);
  },
};
